import {
  canManageDofaProcess,
  canManageRiskAndOppProcess,
  canManageStrategyProcess,
  SERALOGIN_PROCESS_LEADER_BY_PROCESS
} from "../../constants/riskAndOpportunityRoles";

export const canEditByRol = (roleList, roleId) => {
  return canManageDofaProcess(roleList, roleId);
};

export const canEditStrategyByRol = (roleList, roleId) =>
  canManageStrategyProcess(roleList, roleId);

export const canEditRiskAndOpportunityByRol = (roleList, roleId) =>
  canManageRiskAndOppProcess(roleList, roleId);

export const getRolbyProcessId = (processId) =>
  SERALOGIN_PROCESS_LEADER_BY_PROCESS[Number(processId)];
